import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AnimateModule, BasicPage } from '@pro-connect/shared';
import { PillarComponent } from '../../components/pillar/pillar.component';

@Component({
  templateUrl: './pro-experience-pillar.component.html',
  styleUrls: ['./pro-experience-pillar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AnimateModule, PillarComponent],
})
export class ProExperiencePillarComponent extends BasicPage {
  public override readonly loading = signal(false);

  constructor() {
    super();
  }
}
